import { render, staticRenderFns } from "./OrdersPage.vue?vue&type=template&id=890cdfbe&scoped=true&"
import script from "./OrdersPage.vue?vue&type=script&lang=js&"
export * from "./OrdersPage.vue?vue&type=script&lang=js&"
import style0 from "./OrdersPage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrdersPage.vue?vue&type=style&index=1&id=890cdfbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890cdfbe",
  null
  
)

export default component.exports